var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('h1',{staticClass:"tw-font-bold tw-text-light-green"},[_vm._v("404")]),_c('h2',[_vm._v("Sorry, Page not found")]),_c('a',{attrs:{"href":"/"}},[_c('v-btn',{staticClass:"tw-mt-10",attrs:{"outlined":""}},[_vm._v("Go back to Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }